<template>
  <div
    :class="{'shorttag-update-btn': btnType === 'update'}"
  >
    <b-button
      variant="light"
      @click="openModal"
    >
      <template v-if="btnType === 'update'">
        {{ $t('tiptap:btn.edit') }}
      </template>
      <template v-else>
        Zuletzt angesehene Objekte
      </template>
    </b-button>
    <modal
      :name="modalName"
      :scrollable="true"
      height="auto"
      width="600px"
      @close="closeModal"
    >
      <b-button
        class="modal-close"
        variant="light"
        @click="closeModal"
      >
        <i class="icon"><icon-times /></i>
      </b-button>
      <div class="modal-header">
        <h4 class="text-center mb-4">
          last seen objects
        </h4>
      </div>
      <div class="modal-body m-4">
        <div class="container">
          <div class="form-group">
            <b-form-input
              v-model="title"
              placeholder="title"
              type="text"
            />
          </div>
          <b-button
            class="btn btn-secondary mr-2"
            @click.prevent="emitData(btnType)"
          >
            {{ $t('tiptap:btn.ok') }}
          </b-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { BFormInput, BButton } from 'bootstrap-vue';
import IconTimes from 'ICON:IconTimes';

export default ({
  name: 'LastSeenObjectsBtn',
  components: {
    BFormInput,
    BButton,
    IconTimes,
  },
  props: {
    // button can insert new or update existing shorttag
    btnType: {
      type: String,
      default: 'insert',
    },
    titleProp: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // modal name has to be unique
      modalName: `lastSeenObjectsBtnModal_${this.btnType}_${Math.floor(Math.random() * 1000)}`,
      title: '',
    };
  },
  methods: {
    closeModal() {
      this.title = '';
      this.$modal.hide(this.modalName);
    },
    emitData() {
      this.$emit(`${this.btnType}-content`, {
        type: 'LastSeenObjectsShorttag',
        attrs: {
          title: this.title,
        },
      });
      this.closeModal();
    },
    openModal() {
      this.title = this.titleProp ? this.titleProp : '';
      this.$modal.show(this.modalName);
    },
  },
});
</script>
